'use client';
import { isUndefined } from '@s7/utils';
import { sortBreakpoints, getNextBreakpoint } from '../../../modules/responsive/breakpoints/breakpoints.js';
import { getSize } from '../../../modules/sizes/impl/getSize/getSize.js';
import { unit, rem, em } from '../../../modules/sizes/impl/units/units.js';

function createBreakpointFns(breakpoints) {
    const sortedBreakpoints = sortBreakpoints(breakpoints);
    const getEvaluatedSize = (size)=>getSize({
            size,
            sizes: breakpoints
        });
    const media = (query, noMediaKeyword)=>{
        return `${!noMediaKeyword ? '@media ' : ''}${query}`;
    };
    const convert = (raw, units)=>{
        if (units === 'rem') {
            return rem(raw);
        } else if (units === 'em') {
            return em(raw);
        }
        return `${raw}px`;
    };
    const up = (from, units, noMediaKeyword)=>{
        const value = unit(getEvaluatedSize(from));
        const width = convert(Number.isNaN(value) ? from : value, units);
        return media(`(min-width: ${width})`, noMediaKeyword);
    };
    const down = (from, units, noMediaKeyword)=>{
        const value = unit(getEvaluatedSize(from));
        const width = convert(Number.isNaN(value) ? from : value - 1, units);
        return media(`(max-width: ${width})`, noMediaKeyword);
    };
    const between = (from, to, units, noMediaKeyword)=>{
        const _from = unit(getEvaluatedSize(from));
        const _to = unit(getEvaluatedSize(to));
        const startValue = Math.min(_from, _to);
        const endValue = Math.max(_from, _to);
        const startWidth = convert(Number.isNaN(startValue) ? from : startValue, units);
        const endWidth = convert(Number.isNaN(endValue) ? to : endValue - 1, units);
        return media(`(min-width: ${startWidth}) and (max-width: ${endWidth})`, noMediaKeyword);
    };
    const only = (from, units, noMediaKeyword)=>{
        if (isUndefined(breakpoints[from])) {
            throw new Error('Функция темы only поддерживает только размеры ThemeBreakpointSize');
        }
        const startWidth = convert(unit(breakpoints[from]), units);
        const endWidth = getNextBreakpoint(sortedBreakpoints, from);
        if (endWidth) {
            return media(`(min-width: ${startWidth}) and (max-width: ${convert(endWidth.value - 1, units)})`, noMediaKeyword);
        }
        return media(`(min-width: ${startWidth})`, noMediaKeyword);
    };
    const not = (from, units, noMediaKeyword)=>{
        if (isUndefined(breakpoints[from])) {
            throw new Error('Функция темы not поддерживает только размеры ThemeBreakpointSize');
        }
        const startWidth = convert(unit(breakpoints[from]) - 1, units);
        const endWidth = getNextBreakpoint(sortedBreakpoints, from);
        if (endWidth) {
            return media(`(max-width: ${startWidth}) and (min-width: ${convert(endWidth.value, units)})`, noMediaKeyword);
        }
        return '';
    };
    return {
        up,
        down,
        between,
        only,
        not
    };
}

export { createBreakpointFns };
//# sourceMappingURL=breakpoints.js.map
